var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"authorize-btns"},[_c('div',{on:{"click":function($event){return _vm.pageChange('lawservice', 'to-vip-center-btn')}}},[_vm._v("前往会员中心查看全部权益")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }